import React from "react";
import { connect } from "react-redux";
import Box from "@mui/material/Box";
import { withRouter } from "tools/routerCompat";
import { MCard } from "components/Shared";
import Button from "@mui/material/Button";
import { setSelectedCustomerNumber } from "actions/customer";
import WebConfig from "middlewares/WebConfig";
import { userHasRight } from "selectors/rights";
import { CUSTOMER_BILLING_MAINTENANCE } from "typeConstants/rights";

interface CustomerNavigationCardProps {
  verticalDisplay: boolean;
  customerNumber: number; // Customer number to select when opening survey types
  canAccessCustomerBilling: boolean;
  // Redux
  setSelectedCustomerNumber: (customerNumber: string | number) => void;
  // Router
  history: any;
  token: string;
}

interface CustomerNavigationButton {
  title: string;
  onClick: () => void;
};

const CustomerNavigationCard = (props: CustomerNavigationCardProps) => {

  const navigateToSurveyTypes = () => {
    props.setSelectedCustomerNumber(props.customerNumber);
    props.history.push({
      pathname: "/customer/survey-types",
    });
  };

  const navigateToHubSite = (windowName: string, returnUrl: string) => {
    const url = `${WebConfig.hubRoot}/Account/LoginToken?returnUrl=${encodeURIComponent(returnUrl)}&${WebConfig.ssoTokenName}=${encodeURIComponent(props.token)}`
    window.open(url, windowName);
  };

  const navigateToCustomerFeatures = () => {
    // Route the user to the hub site with sso token to login
    const windowName = `CustomerFeaturesHub${props.customerNumber}`
    const returnUrl = `/Customers/Features?CustomerNumber=${props.customerNumber}`; // becomes the returnUrl
    navigateToHubSite(windowName, returnUrl);
  };

  const navigateToBillingDiscounts = () => {
    // Route the user to the hub site with sso token to login
    const windowName = `BillingDiscountsHub${props.customerNumber}`
    let returnUrl = `/Customers/BillingTimeServiceDiscounts?CustomerNumber=${props.customerNumber}`; // becomes the returnUrl
    navigateToHubSite(windowName, returnUrl);
  };

  const buttons: CustomerNavigationButton[] = [
    {
      title: "Open Survey Types",
      onClick: navigateToSurveyTypes
    },
    {
      title: "Open Features Hub",
      onClick: navigateToCustomerFeatures
    }
  ];

  if (props.canAccessCustomerBilling) {
    buttons.push({
      title: "Open Billing / Discount Rules",
      onClick: navigateToBillingDiscounts,
    });
  }

  return (
    <MCard
      title={"Additional Information"}
      children={
        <Box sx={{ display: 'inline-grid' }}>
          {buttons.map((b, i) => (
            <React.Fragment key={b.title}>
              <Button
                onClick={b.onClick}
              >
                {b.title}
              </Button>
              {i < buttons.length - 1 ? <br /> : <></>}
            </React.Fragment>
          ))}
        </Box>
      }
    />
  );
};

const mapStateToProps = state => ({
  token: state.user.profile.token,
  canAccessCustomerBilling: userHasRight(CUSTOMER_BILLING_MAINTENANCE)(state),
});

const mapDispatchToProps = dispatch => ({
  setSelectedCustomerNumber(customerNumber: string | number) {
    dispatch(setSelectedCustomerNumber(customerNumber));
  }
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CustomerNavigationCard));
